import { CreateClient } from './CreateClient';

export const Clients = () => {
  return <CreateClient />;
};
